// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Map_wrap__3kSIf","groupName":"Map_groupName__2L5Jt","location":"Map_location__1E0u8","linkIcon":"Map_linkIcon__1s0UN"};